module.exports = __webpack_public_path__ + "img/MapThumb_NewInland.21a0ad2d.webp";